import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import BlogFormLayer from "../components/BlogFormLayer";

const BlogFormPage = () => {
    return (
        <MasterLayout>
            <BlogFormLayer />
        </MasterLayout>
    );
};

export default BlogFormPage;
